export const newsItems = [
  {
    id: 'n1',
    type: 'news',
    title: '全国多地推出消费补贴新政 激发市场活力',
    summary: '新一轮促消费政策密集落地，覆盖家电、汽车、餐饮等重点领域，多地配套发放消费券，市场热度明显回升。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20city%20shopping%20street%20crowd%20with%20bright%20storefronts%20at%20dusk%2C%20editorial%20news%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20lighting%2C%20high%20detail%2C%20professional%20composition%2C%20muted%20color%20palette&width=800&height=600&seq=news-01&orientation=landscape',
    category: 'news',
    subCategory: '财经',
    author: '林嘉言',
    source: '91网站财经组',
    publishTime: '2026-10-08 09:20',
    views: 128400,
    tags: ['消费补贴', '市场活力', '经济'],
    content: [
      '随着新一轮促消费政策密集落地，全国多个城市陆续推出消费补贴与消费券发放计划，覆盖家电、汽车、餐饮、文旅等重点领域，旨在进一步释放居民消费潜力，激发市场活力。',
      '记者走访发现，多家商场在政策落地首周便迎来客流高峰，家电以旧换新专区咨询量明显上升。相关负责人表示，补贴政策与商家让利叠加，让消费者的实际支付成本明显降低，购买意愿随之增强。',
      '业内专家分析认为，消费补贴在短期内能够有效带动重点品类销售，同时也有助于提振市场信心。但要形成长期效应，还需在增加居民收入、优化消费环境等方面持续发力，让消费真正成为拉动经济增长的稳定动力。',
      '下一步，相关部门将持续跟踪政策实施效果，适时优化补贴范围与力度，并加强对补贴资金使用的监督管理，确保政策红利真正惠及广大消费者。',
    ],
  },
  {
    id: 'n2',
    type: 'news',
    title: '新一代人工智能大模型发布 多模态能力显著提升',
    summary: '国内团队发布新一代大模型，在文本、图像与语音多模态理解与生成上均有提升，加速行业应用落地。',
    image:
      'https://readdy.ai/api/search-image?query=Futuristic%20technology%20lab%20with%20glowing%20data%20visualization%20screens%20and%20minimal%20desk%2C%20editorial%20tech%20news%20photography%2C%20clean%20dark%20neutral%20background%2C%20soft%20lighting%2C%20high%20detail%2C%20professional%20composition&width=800&height=600&seq=news-02&orientation=landscape',
    category: 'news',
    subCategory: '科技',
    author: '陈牧之',
    source: '91网站科技组',
    publishTime: '2026-10-07 15:05',
    views: 213600,
    tags: ['人工智能', '大模型', '多模态'],
    content: [
      '国内研发团队日前正式发布新一代人工智能大模型，在文本理解、图像生成与语音交互等多模态能力上实现明显提升，并进一步降低了推理成本，为行业应用普及创造了条件。',
      '据技术团队介绍，新模型在训练数据质量与算法架构上做了大量优化，长文本理解与逻辑推理表现更加稳定，在医疗、教育、制造等垂直场景中的测试效果获得多方认可。',
      '多位从业者表示，大模型能力提升的同时，如何保障数据安全与内容合规同样是行业关注重点。有关方面将推动建立更加完善的技术标准与治理规范，促进人工智能健康有序发展。',
      '业内预计，随着模型能力不断增强、调用成本持续下降，人工智能将进一步融入日常生产生活，成为推动产业升级的重要力量。',
    ],
  },
  {
    id: 'n3',
    type: 'news',
    title: '城市轨道交通网络扩容 多条新线同步开通',
    summary: '本市轨道交通多条新线路同步开通试运营，线网进一步加密，市民跨区通勤出行更加便捷高效。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20modern%20subway%20station%20platform%20with%20bright%20lighting%20and%20glass%20architecture%2C%20editorial%20urban%20news%20photography%2C%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail%2C%20professional%20composition&width=800&height=600&seq=news-03&orientation=landscape',
    category: 'news',
    subCategory: '社会',
    author: '周晓航',
    source: '91网站社会组',
    publishTime: '2026-10-07 08:40',
    views: 96500,
    tags: ['轨道交通', '城市出行', '民生'],
    content: [
      '本市轨道交通网络迎来新一轮扩容。多条新线路日前同步开通试运营，线网覆盖范围进一步扩大，多个此前尚未通地铁的区域正式迈入轨道交通时代。',
      '新线开通后，中心城区与外围组团之间的通行时间明显缩短。不少市民表示，以往需要多次换乘的公交通勤如今可以一线直达，通勤体验大幅改善。',
      '运营方介绍，新线在列车调度、智能安检与无障碍设施等方面进行了升级，并同步优化了与公交、骑行等出行方式的接驳，方便市民“最后一公里”出行。',
      '相关部门提醒，新线开通初期客流尚在培育阶段，市民可通过官方渠道实时查询线路走向与首末班时间，合理安排出行计划。',
    ],
  },
  {
    id: 'n4',
    type: 'news',
    title: '秋冬季流感高发 专家支招科学防护',
    summary: '随着气温下降，呼吸道疾病进入高发期。专家提醒做好个人防护、及时接种疫苗，重点人群需格外注意。',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20clean%20healthcare%20scene%20with%20medical%20mask%20thermometer%20and%20warm%20blanket%20on%20simple%20table%2C%20editorial%20health%20news%20photography%2C%20light%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=news-04&orientation=landscape',
    category: 'news',
    subCategory: '健康',
    author: '赵梓萱',
    source: '91网站健康组',
    publishTime: '2026-10-06 11:15',
    views: 87200,
    tags: ['流感', '健康防护', '疫苗'],
    content: [
      '进入秋冬季，气温持续下降，呼吸道传染病进入高发期。医疗机构门诊数据显示，近期流感样病例有所增多，老人、儿童及慢性病患者等为重点人群。',
      '专家建议，公众应保持良好的个人卫生习惯，勤洗手、常通风，前往人群密集场所时科学佩戴口罩。同时，建议符合条件的人群及时接种流感疫苗，降低感染与重症风险。',
      '专家特别提醒，出现发热、咳嗽等症状时应及时就医，避免带病上班上学，减少交叉感染。居家期间应注意休息、多饮水，并做好家庭成员之间的防护。',
      '此外，均衡饮食、规律作息与适度运动有助于增强免疫力。保持室内空气流通、注意保暖，也能有效减少呼吸道疾病的发生。',
    ],
  },
  {
    id: 'n5',
    type: 'news',
    title: '中小学课后服务提质升级 拓展多样课程',
    summary: '多所学校丰富课后服务内容，引入科技、艺术、体育等课程，帮助学生全面发展，缓解家长接送难题。',
    image:
      'https://readdy.ai/api/search-image?query=Bright%20modern%20classroom%20with%20colorful%20learning%20materials%20and%20children%20artwork%20on%20walls%2C%20editorial%20education%20news%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=news-05&orientation=landscape',
    category: 'news',
    subCategory: '教育',
    author: '吴清和',
    source: '91网站教育组',
    publishTime: '2026-10-05 16:30',
    views: 74100,
    tags: ['课后服务', '教育', '学生成长'],
    content: [
      '为满足学生多样化成长需求，多地中小学持续推进课后服务提质升级，在原有作业辅导的基础上，引入科技、艺术、体育、阅读等丰富课程，让课后时光更加充实。',
      '记者在一所小学看到，放学后的校园依然热闹，机器人编程、合唱、足球、书法等社团活动同步开展。学校负责人表示，课程设置充分考虑学生兴趣，力求让每个孩子都能找到自己的舞台。',
      '家长们普遍反映，课后服务不仅缓解了接送难题，也让孩子在轻松的氛围中培养了兴趣特长。教育部门表示，将持续完善课程供给与师资保障，提升课后服务的质量与吸引力。',
      '专家建议，课后服务应注重学生身心健康，避免简单延长学习时间，通过丰富多元的活动促进学生全面发展。',
    ],
  },
  {
    id: 'n6',
    type: 'news',
    title: '全国运动会圆满落幕 多项纪录被刷新',
    summary: '本届运动会历时十余天，来自各地的运动员奋力拼搏，多项赛事纪录被刷新，全民健身氛围更加浓厚。',
    image:
      'https://readdy.ai/api/search-image?query=Dramatic%20stadium%20scene%20with%20running%20track%20and%20bright%20floodlights%20at%20evening%2C%20editorial%20sports%20news%20photography%2C%20clean%20neutral%20background%2C%20soft%20lighting%2C%20high%20detail&width=800&height=600&seq=news-06&orientation=landscape',
    category: 'news',
    subCategory: '体育',
    author: '郑远',
    source: '91网站体育组',
    publishTime: '2026-10-04 22:10',
    views: 158300,
    tags: ['运动会', '体育', '全民健身'],
    content: [
      '经过十余天的激烈角逐，全国运动会日前圆满落幕。来自各地的运动员在赛场上奋力拼搏，展现出良好的竞技状态与体育精神，多项赛事纪录被刷新。',
      '本届运动会设项丰富，既有传统优势项目，也有贴近大众的新兴项目，吸引了大批观众到场观赛。赛事期间，志愿服务、安保医疗等保障工作有序开展，获得广泛好评。',
      '组委会表示，运动会不仅是竞技水平的集中展示，也进一步带动了全民健身热潮。赛事结束后，多座场馆将向公众开放，让更多人享受运动的乐趣。',
      '业内人士认为，大型赛事的举办有助于推动体育产业发展，激发大众参与热情，为全民健身与竞技体育协同发展注入新动力。',
    ],
  },
  {
    id: 'n7',
    type: 'news',
    title: '多部门联合部署冬季能源保供工作',
    summary: '相关部门统筹协调，加强煤炭、电力、天然气等能源供应保障，确保群众温暖过冬、企业平稳生产。',
    image:
      'https://readdy.ai/api/search-image?query=Industrial%20energy%20facility%20with%20pipes%20and%20towers%20under%20clear%20sky%20at%20dawn%2C%20editorial%20news%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail%2C%20professional%20composition&width=800&height=600&seq=news-07&orientation=landscape',
    category: 'news',
    subCategory: '社会',
    author: '孙立',
    source: '91网站社会组',
    publishTime: '2026-10-03 10:00',
    views: 61300,
    tags: ['能源保供', '冬季', '民生'],
    content: [
      '随着冬季临近，多部门联合部署能源保供工作，统筹协调煤炭、电力、天然气等能源的生产与供应，全力保障群众温暖过冬、企业平稳生产。',
      '有关方面表示，已提前做好储煤、储气等储备工作，并加强跨区域调度与运输保障，确保重点时段、重点地区的能源供应稳定可靠。',
      '同时，相关部门将密切跟踪天气变化与用能需求，及时研判供需形势，完善应急预案，切实守牢能源安全底线。',
      '专家指出，在保障供应的同时，也应持续推进节能降耗，倡导绿色低碳的生产生活方式，实现能源保供与可持续发展相互促进。',
    ],
  },
  {
    id: 'n8',
    type: 'news',
    title: '文化旅游消费热度攀升 特色活动亮点纷呈',
    summary: '各地推出丰富多彩的文旅活动，博物馆、古镇、非遗体验等受到欢迎，文化旅游消费热度持续攀升。',
    image:
      'https://readdy.ai/api/search-image?query=Charming%20ancient%20town%20with%20warm%20lanterns%20and%20visitors%20along%20a%20stone%20path%20at%20dusk%2C%20editorial%20culture%20travel%20photography%2C%20soft%20neutral%20background%2C%20warm%20lighting%2C%20high%20detail&width=800&height=600&seq=news-08&orientation=landscape',
    category: 'news',
    subCategory: '文化',
    author: '林嘉言',
    source: '91网站文娱组',
    publishTime: '2026-10-02 14:25',
    views: 79800,
    tags: ['文旅', '非遗', '消费'],
    content: [
      '随着假期临近，各地纷纷推出丰富多彩的文化旅游活动，博物馆夜游、古镇巡演、非遗手作体验等项目受到游客欢迎，文化旅游消费热度持续攀升。',
      '在多个历史文化街区，传统技艺展示与创意市集相映成趣，游客在游览之余还能亲手体验制作过程，感受传统文化的独特魅力。',
      '业内人士表示，文化与旅游深度融合，让旅游不再只是“看风景”，而是成为一次有深度的文化体验，也带动了周边餐饮、住宿等行业发展。',
      '相关部门提示，游客出行前可通过官方平台了解活动安排与预约信息，合理规划行程，注意错峰出行与文明旅游。',
    ],
  },
  {
    id: 'n9',
    type: 'news',
    title: '新能源汽车出口再创新高 产业链韧性增强',
    summary: '我国新能源汽车出口保持增长态势，海外市场认可度提升，产业链协同能力与技术水平不断增强。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20electric%20car%20charging%20at%20sleek%20station%20with%20minimal%20architecture%20background%2C%20editorial%20industry%20news%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=news-09&orientation=landscape',
    category: 'news',
    subCategory: '财经',
    author: '陈牧之',
    source: '91网站财经组',
    publishTime: '2026-10-01 09:50',
    views: 112900,
    tags: ['新能源汽车', '出口', '产业链'],
    content: [
      '最新数据显示，我国新能源汽车出口保持增长态势，再创新高。凭借较强的产品竞争力与完善的供应链体系，国产新能源汽车在海外市场的认可度不断提升。',
      '业内分析认为，出口增长的背后是产业链协同能力的增强。从电池、电控到整车制造，完整的产业配套为企业快速响应市场需求提供了有力支撑。',
      '与此同时，企业持续加大研发投入，在续航、智能驾驶与安全性能等方面不断突破，产品体验持续改善，进一步增强了国际市场竞争力。',
      '专家表示，面对全球市场竞争，企业应更加注重品牌建设与本地化服务，推动新能源汽车产业高质量发展。',
    ],
  },
  {
    id: 'n10',
    type: 'news',
    title: '数字人民币试点场景持续拓展 覆盖更多民生领域',
    summary: '数字人民币应用场景不断丰富，在交通、零售、政务缴费等领域加快落地，为公众提供更多支付选择。',
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20mobile%20payment%20at%20minimal%20cafe%20counter%20with%20soft%20bokeh%20background%2C%20editorial%20finance%20news%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=news-10&orientation=landscape',
    category: 'news',
    subCategory: '科技',
    author: '周晓航',
    source: '91网站科技组',
    publishTime: '2026-09-30 17:35',
    views: 68400,
    tags: ['数字人民币', '支付', '金融科技'],
    content: [
      '数字人民币试点工作持续推进，应用场景不断丰富。目前，数字人民币已在交通出行、零售消费、政务缴费等多个民生领域加快落地，为公众提供了更多元的支付选择。',
      '在多地试点中，数字人民币钱包开通流程更加便捷，部分场景还推出了消费优惠活动，吸引不少市民尝鲜体验。',
      '有关方面介绍，数字人民币具有安全、便捷、可控匿名等特点，在保障支付效率的同时，也有助于提升金融服务的普惠性。',
      '下一步，相关部门将在风险可控的前提下稳步扩大试点范围，丰富应用场景，让数字人民币更好地服务实体经济和百姓生活。',
    ],
  },
];